import React from "react";
import "./assets/css/create-account-signup.scss";
import "./assets/css/additonal-signup.scss";
import MainSignup from "./mainSignup";
import AdditionalSingup from "./additionalSignup";
import Autheader from "../../layout/header/autheader.js";
import { signupExpert } from "../../../api/actions/signup";
import { navigateTo } from "gatsby";
export default function ExpertSignup() {
  const [mainScreen, navigateScreen] = React.useState(true);
  const [formData, setFormData] = React.useState({});
  const [error, setError] = React.useState("");
  const handleSingup = () => {
    navigateScreen(false);
  };

  const handleMainSignup = (form) => {
    setFormData(form);
    navigateScreen(false);
  };

  const handleAdditionalSignup = async (form) => {
    console.log("FORM", form);
    console.log("FORM DATA ALREADY", formData);
    const formObj = { ...formData, ...form };
    console.log("FORM DATA", formObj);
    const result = await signupExpert(formObj);
    if (result && result.success) navigateTo("/signup/confirmation?expert");
    else {
      navigateScreen(true);
      setError("Email is already in use");
    }
  };
  return (
    <>
      <Autheader />
      {mainScreen ? (
        <MainSignup error={error} handleMainSignup={handleMainSignup} />
      ) : (
        <AdditionalSingup handleAdditionalSignup={handleAdditionalSignup} />
      )}
    </>
  );
}
